import React from "react";
import { Link } from "react-router-dom";
import { FaExclamationTriangle } from "react-icons/fa";

export default function StorageLimitModal({ open, onClose }) {
    if (!open) return null;

    return (
        <>
            <div className="modal fade show d-block" tabIndex="-1">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content modern-modal">

                        {/* Header */}
                        <div className="modal-header border-0 pb-0">
                            <div className="d-flex align-items-center gap-2">
                                <FaExclamationTriangle size={26} className="text-warning" />
                                <h5 className="modal-title fw-semibold">Storage Limit Reached</h5>
                            </div>
                            <button type="button" className="btn-close" onClick={onClose}></button>
                        </div>

                        {/* Body */}
                        <div className="modal-body text-center pt-2">
                            <p className="text-muted fs-6 mb-0">
                                Your storage is full.  
                                Upgrade your plan to continue uploading.
                            </p>
                        </div>

                        {/* Footer */}
                        <div className="modal-footer border-0 justify-content-center">
                            <Link
                                to="/purchase-subscription"
                                className="upgrade-btn w-100 text-center"
                            >
                                Upgrade Plan
                            </Link>
                        </div>

                    </div>
                </div>
            </div>

            {/* Backdrop with blur */}
            <div className="modal-backdrop fade show modern-backdrop"></div>
        </>
    );
}
